import { createFileRoute } from "@tanstack/react-router";
import { LegalPagesPage } from "@/admin/pages/LegalPagesPage";

export const Route = createFileRoute("/admin/legal")({
  component: LegalPagesPage,
});
